export const aciHalfMealPlan = {
    iconName: 'half-meal-plan',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M7.178 9.969a.5.5 0 01.5.5v12.857a.5.5 0 01-1 0V10.469a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.75 2.824a.5.5 0 01.5.5V9.04a.929.929 0 101.857 0V3.324a.5.5 0 011 0V9.04a1.929 1.929 0 01-3.857 0V3.324a.5.5 0 01.5-.5zM17.893 3.54a.5.5 0 01.5.5v18.57a.5.5 0 01-1 0V4.04a.5.5 0 01.5-.5zM15.75 8.11c-2.07 0-3.52.898-3.944 1.293a.5.5 0 11-.682-.73c.597-.558 2.288-1.564 4.627-1.564a.5.5 0 010 1zM15.75 19.969c-2.07 0-3.52-.9-3.944-1.294a.5.5 0 10-.682.73c.597.558 2.288 1.564 4.627 1.564a.5.5 0 000-1z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
